module.exports = __webpack_public_path__ + "img/HV.390ea368.png";